module.exports = __webpack_public_path__ + "Server-Unknown.AzureCloudService.b9e9584ba85bcb6b7903d303ab35084a.hashedasset.svg";